// src/components/Reports.js
import React from 'react';

export default function Reports() {
  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Reports</h2>

      {/* Customer Report */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>Customer Report</h3>
        <p style={styles.description}>
          Overview of all registered customers, their activity status, and engagement data.
        </p>
        <div style={styles.placeholder}>
          <p style={styles.placeholderText}>📋 Customer report data will appear here</p>
        </div>
      </div>

      {/* Sales Report */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>Sales Report</h3>
        <p style={styles.description}>
          Summary of sales performance, revenue trends, and dealer transactions.
        </p>
        <div style={styles.placeholder}>
          <p style={styles.placeholderText}>💰 Sales report data will appear here</p>
        </div>
      </div>

      {/* Mandatory Inspection Report */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>Mandatory Inspection Report</h3>
        <p style={styles.description}>
          Details of customer inspections — pending, completed, and overdue tasks.
        </p>
        <div style={styles.placeholder}>
          <p style={styles.placeholderText}>🔍 Inspection report data will appear here</p>
        </div>
      </div>
    </div>
  );
}

// Internal CSS styles
const styles = {
  container: {
    padding: '2rem',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    backgroundColor: '#f4f6f8',
    minHeight: '100vh',
  },
  title: {
    textAlign: 'center',
    marginBottom: '2rem',
    fontSize: '2rem',
    color: '#333',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    padding: '1.5rem',
    marginBottom: '2rem',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  cardTitle: {
    fontSize: '1.4rem',
    color: '#2e86de',
    marginBottom: '0.5rem',
  },
  description: {
    fontSize: '1rem',
    color: '#555',
    marginBottom: '1rem',
  },
  placeholder: {
    border: '2px dashed #ccc',
    borderRadius: '8px',
    height: '150px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fafafa',
  },
  placeholderText: {
    color: '#999',
    fontStyle: 'italic',
  },
};

// Optional hover styling (dynamic card shadow)
const sheet = document.styleSheets[0];
if (sheet) {
  sheet.insertRule(`
    div[style*="box-shadow"]:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 16px rgba(0,0,0,0.15);
    }
  `, sheet.cssRules.length);
}
